export class LiquidDietItemModel {
    time: number;
    volume: number = 0;
    meal_id: string = "";
    meal_name: string = "";
	remarks: string = "";
}